import { event, GtagEvent } from "./event";
import { Item } from "./item";

export interface SelectItem extends GtagEvent {
    item_list_id?:string;
    item_list_name?:string;
    items:Item[],
}
export const select_item = ($_?:SelectItem) => event('select_item',$_);